import { BooleanOperator, SearchBackend } from '@ardoq/api-types';
import { AdvancedSearchStateShape } from './types';
import { SearchContext } from '@ardoq/query-builder';

export const defaultQueryBuilderRules = {
  condition: BooleanOperator.AND,
  rules: [],
};

export const defaultState: AdvancedSearchStateShape = {
  queryBuilderRules: defaultQueryBuilderRules,
  selectedFilterType: SearchContext.COMPONENT,
  selectedCondition: defaultQueryBuilderRules.condition,
  results: [],
  total: 0,
  sortOrder: undefined,
  sortBy: undefined,
  selectedPage: 1,
  selectedFieldNames: [],
  searchError: null,
  isExporting: false,
  showResults: false,
  searchBackend: SearchBackend.ADVANCED_SEARCH,
  selectedSnapshot: null,
  resultFields: [],
};
